import * as React from 'react';
import { Menu as MUIMenu, MenuItem as MUIMenuItem } from '@material-ui/core';
import { extractMenuElements } from './utils';
import { useEvents } from './useEvents';

export * from './MenuTrigger';
export * from './MenuItem';
export * from './styles';

export const Menu: React.FC<{ children: any }> = ({ children }) => {
  const menuRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState<any>(null);

  const handlerTrigger = React.useCallback(() => {
    setAnchorEl(anchorEl ? null : triggerRef.current);
  }, [anchorEl]);

  useEvents(menuRef, triggerRef, handlerTrigger);

  if (children) {
    const { triggerElement, menuItems } = extractMenuElements(children, triggerRef);
    return <>
      {triggerElement}
      <MUIMenu
        ref={menuRef}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handlerTrigger}
      >
        {menuItems}
      </MUIMenu>
    </>;
  }
  return <>{children}</>;
}